/* eslint-disable no-nested-ternary */
import { Delete } from '@mui/icons-material';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { PromotionRequiredDish } from '../../apiTypes';
import { useCafe } from '../../contexts/cafe.context';
import AddDishButton from '../AddDishButton';
import Image from '../Image';
import FormTextField from './FormTextField';

type FormType = Record<string, PromotionRequiredDish[]>;

export type Props = {
  name?: string;
};

const FormDishesBundle = ({ name = 'components' }: Props) => {
  const { dishesMap } = useCafe();
  const { formState, control } = useFormContext();
  const error = formState.errors[name];

  const { fields, append, remove } = useFieldArray<FormType>({
    control,
    name,
    keyName: 'id',
  });

  const filteredOptions = useMemo(
    () => Object.keys(dishesMap).filter((o) => !fields.some((c) => c.dishId === o)),
    [dishesMap, fields]
  );

  return (
    <Box>
      {fields.map(({ dishId }, index) => (
        <Grid
          key={dishId}
          container
          alignItems="center"
          sx={{ p: 0.5, borderRadius: 1, ':hover': { bgcolor: (t) => t.palette.background.default } }}
        >
          <Grid item xs={9}>
            <Box gap={1} sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
              <Image src={dishesMap[dishId]?.imageUrl} />
              <Typography sx={{ lineHeight: 0.8 }}>{dishesMap[dishId]?.name}</Typography>
            </Box>
          </Grid>

          <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center' }}>
            <FormTextField required name={`${name}.${index}.qnt`} size="small" type="number" />

            <IconButton sx={{ width: 32, height: 32, ml: 1, flexShrink: 0 }} size="small" onClick={() => remove(index)}>
              <Delete />
            </IconButton>
          </Grid>
        </Grid>
      ))}

      <Box sx={{ maxWidth: 260 }}>
        <AddDishButton options={filteredOptions} small onAdd={(dishId) => append({ dishId, qnt: 1 })} />
      </Box>
    </Box>
  );
};

export default FormDishesBundle;
